(() => {
  if (window.preaSearchRangeSyncReady) return;
  window.preaSearchRangeSyncReady = true;

  const toNumber = (value, fallback = 0) => {
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
  };

  const countDecimals = (value) => {
    const text = String(value || '');
    const decimalPart = text.split('.')[1];
    return decimalPart ? decimalPart.length : 0;
  };

  const formatPriceInputValue = (value, decimalPlaces) => {
    const formatted = value.toFixed(decimalPlaces);
    return formatted.replace(/\.?0+$/, '');
  };

  const updateSliderFill = (scope) => {
    if (!scope) return;
    const slider = scope.querySelector('.prea-search-price__slider');
    const minRange = scope.querySelector('[data-prea-price-range-input="min"]');
    const maxRange = scope.querySelector('[data-prea-price-range-input="max"]');
    if (!slider || !minRange || !maxRange) return;

    const maxLimit = toNumber(maxRange.max, 100) || 100;
    const minVal = Math.max(0, Math.min(maxLimit, toNumber(minRange.value, 0)));
    const maxVal = Math.max(minVal, Math.min(maxLimit, toNumber(maxRange.value, maxLimit)));
    const minPct = (minVal / maxLimit) * 100;
    const maxPct = (maxVal / maxLimit) * 100;
    slider.style.setProperty('--prea-price-min-pct', `${minPct.toFixed(2)}%`);
    slider.style.setProperty('--prea-price-max-pct', `${maxPct.toFixed(2)}%`);
  };

  const syncRangeToInputs = (range) => {
    const scope = range.closest('[data-prea-price-range]');
    if (!scope) return;

    const minRange = scope.querySelector('[data-prea-price-range-input="min"]');
    const maxRange = scope.querySelector('[data-prea-price-range-input="max"]');
    const minInput = scope.querySelector('[data-prea-price-input="min"]');
    const maxInput = scope.querySelector('[data-prea-price-input="max"]');
    if (!minRange || !maxRange || !minInput || !maxInput) return;

    const maxLimit = toNumber(maxRange.max);
    let minValue = toNumber(minRange.value);
    let maxValue = toNumber(maxRange.value, maxLimit);
    const decimalPlaces = Math.max(
      countDecimals(minRange.step),
      countDecimals(maxRange.step),
      countDecimals(maxRange.max)
    );

    if (minValue > maxValue) {
      if (range.dataset.preaPriceRangeInput === 'min') {
        maxValue = minValue;
        maxRange.value = String(maxValue);
      } else {
        minValue = maxValue;
        minRange.value = String(minValue);
      }
    }

    minInput.value = formatPriceInputValue(minValue, decimalPlaces);
    maxInput.value = formatPriceInputValue(maxValue, decimalPlaces);
    updateSliderFill(scope);
    minInput.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const syncInputToRange = (input) => {
    const scope = input.closest('[data-prea-price-range]');
    if (!scope) return;

    const target = input.dataset.preaPriceInput;
    const range = scope.querySelector(`[data-prea-price-range-input="${target}"]`);
    if (!range) return;

    range.value = input.value || (target === 'min' ? range.min : range.max);
    updateSliderFill(scope);
  };

  const initAllSliders = () => {
    document.querySelectorAll('[data-prea-price-range]').forEach(updateSliderFill);
  };

  document.addEventListener(
    'input',
    (event) => {
      const range = event.target.closest('[data-prea-price-range-input]');
      if (range) {
        event.stopPropagation();
        syncRangeToInputs(range);
        return;
      }

      const input = event.target.closest('[data-prea-price-input]');
      if (input) {
        syncInputToRange(input);
      }
    },
    true
  );

  document.addEventListener('prea:range-sync', (event) => {
    const scope = event.target && event.target.closest ? event.target.closest('[data-prea-price-range]') : null;
    if (scope) updateSliderFill(scope);
  }, true);

  document.addEventListener('DOMContentLoaded', initAllSliders);
  document.addEventListener('prea:search-facets-updated', initAllSliders);
  initAllSliders();
})();

(function () {
  if (window.__preaSearchToolbarInitialized) return;
  window.__preaSearchToolbarInitialized = true;

  var MOTION_DURATION = 340;
  var SORT_DURATION = 270;
  var layoutRaf = null;
  var layoutMetricsForce = false;
  var ROOT_SELECTOR = '.template-search, .collection-grid-section';
  var MOBILE_FILTER_QUERY = '(max-width: 1199px)';
  var COLLECTION_MOBILE_FILTER_QUERY = '(max-width: 989px)';
  var lastCollectionMobileState = window.matchMedia(COLLECTION_MOBILE_FILTER_QUERY).matches;

  function getFacetRoot(element) {
    return element ? element.closest(ROOT_SELECTOR) : document.querySelector(ROOT_SELECTOR);
  }

  function getFacetRoots() {
    return document.querySelectorAll(ROOT_SELECTOR);
  }

  function isCollectionRoot(root) {
    return Boolean(root && root.classList.contains('collection-grid-section'));
  }

  function isDefaultDesktopOpenMenu(menu) {
    return Boolean(menu && menu.getAttribute('data-default-desktop-open') === 'true');
  }

  function isMobileFilterDrawer(element) {
    var root = getFacetRoot(element);
    if (isCollectionRoot(root)) {
      return window.matchMedia(COLLECTION_MOBILE_FILTER_QUERY).matches;
    }
    return window.matchMedia(MOBILE_FILTER_QUERY).matches;
  }

  function setFilterDrawerScrollLock() {
    var hasOpenMobileDrawer = false;
    document.querySelectorAll('[data-prea-filter-menu].is-open').forEach(function (menu) {
      if (isMobileFilterDrawer(menu)) {
        hasOpenMobileDrawer = true;
      }
    });
    document.documentElement.classList.toggle('prea-search-filter-drawer-open', hasOpenMobileDrawer);
  }

  function setToolbarStickyOffset() {
    var offset = 0;
    var selectors = [
      'sticky-header',
      '.shopify-section-header-sticky',
      '#shopify-section-header.shopify-section-header-sticky',
      '.section-header.shopify-section-header-sticky'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var header = document.querySelector(selectors[i]);
      if (!header) continue;

      var style = window.getComputedStyle(header);
      var rect = header.getBoundingClientRect();

      if (
        rect.height > 0 &&
        rect.bottom > 0 &&
        (style.position === 'sticky' || style.position === 'fixed')
      ) {
        offset = Math.round(rect.height);
        break;
      }
    }

    document.documentElement.style.setProperty('--prea-search-toolbar-sticky-top', offset + 'px');

    getFacetRoots().forEach(function (root) {
      root.style.setProperty('--prea-search-toolbar-sticky-top', offset + 'px');
    });
  }

  function setFilterPanelMaxHeight(options) {
    var force = options && options.force;

    getFacetRoots().forEach(function (root) {
      var shell = root.querySelector('.prea-search-toolbar-shell');
      if (!shell) return;

      if (isCollectionRoot(root) && !isMobileFilterDrawer(root)) {
        var menu = root.querySelector('[data-prea-filter-menu].is-open, [data-prea-filter-menu][open]');
        var panel = menu ? menu.querySelector('.prea-search-filter-panel') : null;
        if (panel) {
          var panelHeight = Math.ceil(panel.scrollHeight || panel.getBoundingClientRect().height || 0);
          root.style.setProperty('--prea-desktop-sidebar-height', Math.max(420, panelHeight + 36) + 'px');
        } else {
          root.style.removeProperty('--prea-desktop-sidebar-height');
        }
        return;
      }

      root.style.removeProperty('--prea-desktop-sidebar-height');

      if (!force && root.querySelector('[data-prea-filter-menu].is-open, [data-prea-filter-menu].is-closing')) return;

      var shellRect = shell.getBoundingClientRect();
      var viewportSpace = window.innerHeight - shellRect.bottom - 12;
      var available = Math.max(0, viewportSpace);

      root.style.setProperty('--prea-filter-panel-max-height', available + 'px');
    });
  }

  function resetFilterPanelEdgeLock(root) {
    root.style.removeProperty('--prea-filter-panel-y-shift');
    root.style.removeProperty('--prea-filter-panel-top-clip');
  }

  function setRootPixelProperty(root, property, value) {
    var nextValue = value + 'px';

    if (root.style.getPropertyValue(property) !== nextValue) {
      root.style.setProperty(property, nextValue);
    }
  }

  function setFilterPanelEdgeLock() {
    getFacetRoots().forEach(function (root) {
      if (isCollectionRoot(root) || isMobileFilterDrawer(root)) {
        resetFilterPanelEdgeLock(root);
        return;
      }

      var menu = root.querySelector(
        '[data-prea-filter-menu][open], [data-prea-filter-menu].is-open, [data-prea-filter-menu].is-closing'
      );

      if (!menu) {
        resetFilterPanelEdgeLock(root);
        return;
      }

      var shell = root.querySelector('.prea-search-toolbar-shell');
      var panel = menu.querySelector('.prea-search-filter-panel');

      if (!shell || !panel) {
        resetFilterPanelEdgeLock(root);
        return;
      }

      var shellRect = shell.getBoundingClientRect();
      var rootRect = root.getBoundingClientRect();
      var panelHeight = panel.getBoundingClientRect().height;
      var overflowAmount = shellRect.bottom + panelHeight - rootRect.bottom;
      var overflow = overflowAmount > 1 ? Math.ceil(overflowAmount) : 0;

      setRootPixelProperty(root, '--prea-filter-panel-y-shift', -overflow);
      setRootPixelProperty(root, '--prea-filter-panel-top-clip', overflow);
    });
  }

  function scheduleLayoutMetrics(options) {
    if (options && options.force) {
      layoutMetricsForce = true;
    }

    if (layoutRaf) return;

    layoutRaf = window.requestAnimationFrame(function () {
      var force = layoutMetricsForce;

      layoutRaf = null;
      layoutMetricsForce = false;
      setToolbarStickyOffset();
      setFilterPanelMaxHeight({ force: force });
      setFilterPanelEdgeLock();
    });
  }

  function setFilterLabels(menu) {
    if (!menu) return;

    var root = getFacetRoot(menu);
    var activeBarChips = root
      ? root.querySelectorAll('[data-prea-active-facets-list] > *')
      : [];
    var panelChips = menu.querySelectorAll('.prea-search-filter__active-chip');
    var count = activeBarChips.length > 0 ? activeBarChips.length : panelChips.length;
    var suffix = count > 0 ? ' (' + count + ')' : '';
    var showLabel = menu.querySelector('[data-prea-filter-show-label]');
    var hideLabel = menu.querySelector('[data-prea-filter-hide-label]');

    if (isCollectionRoot(root)) {
      if (isMobileFilterDrawer(menu)) {
        if (showLabel) showLabel.textContent = 'Filters' + suffix;
        if (hideLabel) hideLabel.textContent = 'Filters' + suffix;
      } else if (isDefaultDesktopOpenMenu(menu)) {
        if (showLabel) showLabel.textContent = 'Filters';
        if (hideLabel) hideLabel.textContent = 'Filters';
      } else {
        if (showLabel) showLabel.textContent = 'Filters' + suffix;
        if (hideLabel) hideLabel.textContent = 'Hide filters' + suffix;
      }
      return;
    }

    if (showLabel) showLabel.textContent = 'Show filters' + suffix;
    if (hideLabel) hideLabel.textContent = 'Hide filters' + suffix;
  }

  function syncAllFilterLabels() {
    document.querySelectorAll('[data-prea-filter-menu]').forEach(setFilterLabels);
  }

  function setSortMenuLayerState() {
    var hasOpenSort = Boolean(document.querySelector('[data-prea-sort-menu].is-open'));

    document.documentElement.classList.toggle('prea-search-sort-menu-open', hasOpenSort);

    getFacetRoots().forEach(function (root) {
      root.classList.toggle('prea-search--sort-open', Boolean(root.querySelector('[data-prea-sort-menu].is-open')));
    });
  }

  function openFilterMenu(menu) {
    if (!menu) return;

    var root = getFacetRoot(menu);
    window.clearTimeout(menu.__preaCloseTimer);

    document.querySelectorAll('[data-prea-sort-menu].is-open').forEach(closeSortMenu);

    scheduleLayoutMetrics({ force: true });

    if (root) {
      root.classList.remove('prea-search--filters-closing');
    }

    menu.open = true;
    menu.classList.remove('is-closing');

    window.requestAnimationFrame(function () {
      menu.classList.add('is-open');

      if (root) {
        root.classList.add('prea-search--filters-open');
      }

      setFilterDrawerScrollLock();
      scheduleLayoutMetrics({ force: true });
    });
  }

  function closeFilterMenu(menu) {
    if (!menu || (!menu.open && !menu.classList.contains('is-open'))) return;

    var root = getFacetRoot(menu);
    window.clearTimeout(menu.__preaCloseTimer);

    if (root) {
      root.classList.remove('prea-search--filters-open');
      root.classList.add('prea-search--filters-closing');
      root.style.removeProperty('--prea-desktop-sidebar-height');
    }

    menu.classList.remove('is-open');
    menu.classList.add('is-closing');
    setFilterDrawerScrollLock();

    menu.__preaCloseTimer = window.setTimeout(function () {
      menu.classList.remove('is-closing');
      menu.open = false;

      if (root) {
        root.classList.remove('prea-search--filters-closing');
        resetFilterPanelEdgeLock(root);
      }

      setFilterDrawerScrollLock();
      scheduleLayoutMetrics({ force: true });
    }, MOTION_DURATION);
  }

  function toggleFilterMenu(menu) {
    if (!menu) return;

    if (menu.classList.contains('is-open')) {
      closeFilterMenu(menu);
    } else {
      openFilterMenu(menu);
    }
  }

  function openSortMenu(menu) {
    if (!menu) return;

    document.querySelectorAll('[data-prea-sort-menu]').forEach(function (otherMenu) {
      if (otherMenu !== menu) {
        closeSortMenu(otherMenu);
      }
    });

    document.querySelectorAll('[data-prea-filter-menu].is-open').forEach(function (filterMenu) {
      var root = getFacetRoot(filterMenu);
      if (!isCollectionRoot(root) || isMobileFilterDrawer(filterMenu)) {
        closeFilterMenu(filterMenu);
      }
    });

    window.clearTimeout(menu.__preaCloseTimer);
    menu.open = true;
    menu.classList.remove('is-closing');

    window.requestAnimationFrame(function () {
      menu.classList.add('is-open');
      setSortMenuLayerState();
    });
  }

  function closeSortMenu(menu) {
    if (!menu || (!menu.open && !menu.classList.contains('is-open'))) return;

    window.clearTimeout(menu.__preaCloseTimer);
    menu.classList.remove('is-open');
    menu.classList.add('is-closing');
    setSortMenuLayerState();

    menu.__preaCloseTimer = window.setTimeout(function () {
      menu.classList.remove('is-closing');
      menu.open = false;
      setSortMenuLayerState();
    }, SORT_DURATION);
  }

  function toggleSortMenu(menu) {
    if (!menu) return;

    if (menu.classList.contains('is-open')) {
      closeSortMenu(menu);
    } else {
      openSortMenu(menu);
    }
  }

  function syncCollectionViewportMode() {
    var isNowMobile = window.matchMedia(COLLECTION_MOBILE_FILTER_QUERY).matches;
    if (isNowMobile === lastCollectionMobileState) return;
    lastCollectionMobileState = isNowMobile;

    document.querySelectorAll('.collection-grid-section [data-prea-filter-menu]').forEach(function (menu) {
      var root = getFacetRoot(menu);
      window.clearTimeout(menu.__preaCloseTimer);
      menu.classList.remove('is-closing');
      if (root) {
        root.classList.remove('prea-search--filters-closing');
      }

      if (isNowMobile) {
        menu.open = false;
        menu.classList.remove('is-open');
        if (root) {
          root.classList.remove('prea-search--filters-open');
          root.style.removeProperty('--prea-desktop-sidebar-height');
        }
      } else if (isDefaultDesktopOpenMenu(menu)) {
        menu.open = true;
        menu.classList.add('is-open');
        if (root) {
          root.classList.add('prea-search--filters-open');
        }
      } else {
        menu.open = false;
        menu.classList.remove('is-open');
        if (root) {
          root.classList.remove('prea-search--filters-open');
          root.style.removeProperty('--prea-desktop-sidebar-height');
        }
      }
      setFilterLabels(menu);
    });
  }

  function syncInitialState() {
    document.querySelectorAll('[data-prea-filter-menu]').forEach(function (menu) {
      var root = getFacetRoot(menu);
      if (isCollectionRoot(root)) {
        if (isMobileFilterDrawer(menu) || !isDefaultDesktopOpenMenu(menu)) {
          menu.open = false;
          menu.classList.remove('is-open');
          if (root) root.classList.remove('prea-search--filters-open');
        } else {
          menu.open = true;
          menu.classList.add('is-open');
          if (root) root.classList.add('prea-search--filters-open');
        }
      } else if (menu.open) {
        menu.classList.add('is-open');
        if (root) {
          root.classList.add('prea-search--filters-open');
        }
      }

      setFilterLabels(menu);
    });

    document.querySelectorAll('[data-prea-sort-menu]').forEach(function (menu) {
      if (menu.open) {
        menu.classList.add('is-open');
      }
    });

    setSortMenuLayerState();
    setFilterDrawerScrollLock();
    scheduleLayoutMetrics({ force: true });
  }

  document.addEventListener(
    'click',
    function (event) {
      var showMoreBtn = event.target.closest('[data-prea-show-more]');
      if (showMoreBtn) {
        event.preventDefault();
        var filterGroup = showMoreBtn.closest('.prea-search-filter__group');
        if (filterGroup) {
          var isExpanded = filterGroup.classList.toggle('is-expanded-list');
          showMoreBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          var moreText = showMoreBtn.querySelector('[data-prea-show-more-text]');
          var lessText = showMoreBtn.querySelector('[data-prea-show-less-text]');
          if (moreText) moreText.hidden = isExpanded;
          if (lessText) lessText.hidden = !isExpanded;
          scheduleLayoutMetrics({ force: true });
        }
        return;
      }

      var filterGroupSummary = event.target.closest('.prea-search-filter__group > summary');
      if (filterGroupSummary) {
        window.setTimeout(function () {
          scheduleLayoutMetrics({ force: true });
        }, 40);
      }

      var filterSummary = event.target.closest('[data-prea-filter-menu] > summary');
      var sortSummary = event.target.closest('[data-prea-sort-menu] > summary');
      var filterBackdrop = event.target.closest('[data-prea-filter-backdrop]');
      var filterClose = event.target.closest('[data-prea-filter-close]');

      if (filterSummary) {
        var clearInHeader = event.target.closest('[data-prea-clear-all]');
        if (clearInHeader) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.clearAllFilters === 'function') {
            FacetFiltersForm.clearAllFilters();
          }
          return;
        }
        var filterMenuEl = filterSummary.closest('[data-prea-filter-menu]');
        var filterRootEl = getFacetRoot(filterMenuEl);
        if (
          isCollectionRoot(filterRootEl) &&
          !isMobileFilterDrawer(filterMenuEl) &&
          isDefaultDesktopOpenMenu(filterMenuEl)
        ) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        toggleFilterMenu(filterMenuEl);
        return;
      }

      if (filterBackdrop) {
        event.preventDefault();
        closeFilterMenu(filterBackdrop.closest('[data-prea-filter-menu]'));
        return;
      }

      if (filterClose) {
        event.preventDefault();
        closeFilterMenu(filterClose.closest('[data-prea-filter-menu]'));
        return;
      }

      if (sortSummary) {
        event.preventDefault();
        toggleSortMenu(sortSummary.closest('[data-prea-sort-menu]'));
        return;
      }

      var sortOption = event.target.closest('[data-prea-sort-option]');

      if (sortOption) {
        var sortMenu = sortOption.closest('[data-prea-sort-menu]');
        var sortInput = sortMenu ? sortMenu.querySelector('[data-prea-sort-input]') : null;
        var sortLabel = sortMenu ? sortMenu.querySelector('[data-prea-sort-label]') : null;
        var selectedValue = sortOption.getAttribute('data-prea-sort-value');

        if (!sortInput || !selectedValue) return;

        sortInput.value = selectedValue;

        if (sortLabel) {
          sortLabel.textContent = sortOption.textContent.trim();
        }

        sortMenu.querySelectorAll('[data-prea-sort-option]').forEach(function (button) {
          var isActive = button === sortOption;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        closeSortMenu(sortMenu);
        sortInput.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }

      document.querySelectorAll('[data-prea-filter-menu].is-open').forEach(function (menu) {
        var root = getFacetRoot(menu);
        if (isCollectionRoot(root) && !isMobileFilterDrawer(menu)) {
          return;
        }
        if (!menu.contains(event.target)) {
          closeFilterMenu(menu);
        }
      });

      document.querySelectorAll('[data-prea-sort-menu].is-open').forEach(function (menu) {
        if (!menu.contains(event.target)) {
          closeSortMenu(menu);
        }
      });
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-prea-filter-menu].is-open').forEach(function (menu) {
      var root = getFacetRoot(menu);
      if (isCollectionRoot(root) && !isMobileFilterDrawer(menu)) {
        return;
      }
      closeFilterMenu(menu);
    });
    document.querySelectorAll('[data-prea-sort-menu].is-open').forEach(closeSortMenu);
  });

  window.addEventListener('resize', function () {
    syncCollectionViewportMode();
    syncAllFilterLabels();
    scheduleLayoutMetrics({ force: true });
    setFilterDrawerScrollLock();
  });
  window.addEventListener('scroll', function () {
    if (document.querySelector('.template-search, .collection-grid-section [data-prea-filter-menu].is-open')) {
      scheduleLayoutMetrics();
    }
  }, { passive: true });

  document.addEventListener('DOMContentLoaded', function () {
    syncInitialState();
    scheduleLayoutMetrics({ force: true });
  });

  document.addEventListener('shopify:section:load', function () {
    syncInitialState();
    scheduleLayoutMetrics({ force: true });
  });

  document.addEventListener('prea:search-facets-updated', function () {
    syncAllFilterLabels();
    setSortMenuLayerState();
    setFilterDrawerScrollLock();
    scheduleLayoutMetrics({ force: true });
  });

  scheduleLayoutMetrics({ force: true });
})();
